module.exports = __webpack_public_path__ + "img/icon-basket.9123623e.svg";